import * as firebase from 'firebase';

// Categories
export const FETCH_CATEGORIES = 'fetch_categories';
export const FETCH_CATEGORIES_SUCCESS = 'fetch_categories_success';

export const ADD_CATEGORY = 'add_category';
export const ADD_CATEGORY_SUCCESS = 'add_category_success';
export const ADD_CATEGORY_FAIL = 'add_category_fail';

export const UPDATE_CATEGORY = 'update_category';
export const UPDATE_CATEGORY_SUCCESS = 'update_category_success';
export const UPDATE_CATEGORY_FAIL = 'update_category_fail';

export const DELETE_CATEGORY = 'delete_category';
export const DELETE_CATEGORY_SUCCESS = 'delete_category_success';
export const DELETE_CATEGORY_FAIL = 'delte_category_fail';


export function fetchAllCategories() {

    const categoriesRef = firebase.database().ref('categories');

    return (dispatch) => {
        dispatch({ type: FETCH_CATEGORIES });

        categoriesRef.on('value', snapshot => {

            if (snapshot) {
                let rawCategories = [];
                snapshot.forEach(rawCategory => {
                    const categoryId = rawCategory.key;
                    const category = rawCategory.val();

                    rawCategories.push({ ...category, id: categoryId });
                });

                dispatch({
                    type: FETCH_CATEGORIES_SUCCESS,
                    payload: rawCategories
                });
            }

        });
    };
}

export function addCategory(category, callback) {

    return (dispatch) => {
        dispatch({ type: ADD_CATEGORY });

        const newCategoryRef = firebase.database().ref('categories').push();

        const updatedCategory = { ...category };
        delete updatedCategory.id;

        newCategoryRef.set(updatedCategory, error => {

            if (error) {
                dispatch({
                    type: ADD_CATEGORY_FAIL,
                    payload: error.message
                });
            } else {
                dispatch({
                    type: ADD_CATEGORY_SUCCESS
                });
            }

            if (callback) {
                callback(error);
            }
        });
    };
}

export function updateCategory(category, callback) {

    return (dispatch) => {
        dispatch({ type: UPDATE_CATEGORY });

        const categoryRef = firebase.database().ref('categories').child(category.id);
        
        const updatedCategory = { ...category };
        delete updatedCategory.id;


        categoryRef.update(updatedCategory, error => {

            if (error) {
                dispatch({
                    type: UPDATE_CATEGORY_FAIL,
                    payload: error.message
                });
            } else {
                dispatch({
                    type: UPDATE_CATEGORY_SUCCESS
                });
            }

            if (callback) {
                callback(error);
            }
        });
    };
}

export function deleteCategory(id, callback) {

    return (dispatch) => {
        dispatch({ type: DELETE_CATEGORY });

        const categoryRef = firebase.database().ref('categories').child(id);

        console.log(categoryRef);

        categoryRef.remove(error => {
            if (error) {
                dispatch({
                    type: DELETE_CATEGORY_FAIL,
                    payload: error.message
                });
            } else {
                dispatch({
                    type: DELETE_CATEGORY_SUCCESS
                });
            }

            if (callback) {
                callback(error);
            }
        });

    };
}


// WEBPACK FOOTER //
// ./src/actions/CategoryActions.js